
import React, {FC} from 'react';
import classNames from 'classnames';
import DynamicAsset from 'components/DynamicAsset';
import {Markdown} from 'components/Markdown';
import {BG} from 'constants/index';

import R_Hearts from './svgs/r_hearts.inline.svg';
import R_Wow from './svgs/r_wow.inline.svg';

import * as styles from './styles.module.scss';

export type CardProps = {
	bg?: BG
	heading: {
		profile: string
		name: string
		location: string
	}
	text: string
	images: string[]
	reactions: {
		type: 'wow' | 'hearts',
		count: string
	}
}

export const Card: FC<CardProps> = ({
	bg,
	heading,
	text,
	images,
	reactions,
}) => {
	return (
		<div className={classNames({
			[styles.card]: true,
			[styles.light]: bg === BG.light,
		})}>
			<div className={styles.heading}>
				<DynamicAsset
					className={styles.profile}
					imageSrc={heading.profile}
				/>
				<div className={styles.title}>
					<span>{heading.name}</span>
					<span>{heading.location}</span>
				</div>
			</div>
			<Markdown spanify
				className={styles.text}
				markdown={text}
			/>
			<div className={styles.images}>
				{images.map((url, i) => (
					<DynamicAsset imageSrc={url} key={i} />
				))}
			</div>
			<div className={styles.reactions}>
				{reactions.type === 'wow' && <R_Wow />}
				{reactions.type === 'hearts' && <R_Hearts />}
				{reactions.count}
			</div>
		</div>
	);
};
